import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
const ThemeProviderContext = createContext(undefined);
export function ThemeProvider({ children, defaultTheme = 'system', storageKey = 'speedpress-theme', }) {
    const [theme, setTheme] = useState(defaultTheme);
    const [actualTheme, setActualTheme] = useState('light');
    useEffect(() => {
        // Load theme from localStorage on mount
        const storedTheme = localStorage.getItem(storageKey);
        if (storedTheme) {
            setTheme(storedTheme);
        }
    }, [storageKey]);
    useEffect(() => {
        const root = document.documentElement;
        // Remove existing theme classes
        root.classList.remove('light', 'dark');
        let effectiveTheme;
        if (theme === 'system') {
            effectiveTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        }
        else {
            effectiveTheme = theme;
        }
        // Apply the theme class
        root.classList.add(effectiveTheme);
        setActualTheme(effectiveTheme);
        // Store theme preference
        localStorage.setItem(storageKey, theme);
    }, [theme, storageKey]);
    // Listen for system theme changes
    useEffect(() => {
        if (theme !== 'system')
            return;
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => {
            const newTheme = e.matches ? 'dark' : 'light';
            document.documentElement.classList.remove('light', 'dark');
            document.documentElement.classList.add(newTheme);
            setActualTheme(newTheme);
        };
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, [theme]);
    const value = {
        theme,
        setTheme,
        actualTheme,
    };
    return (_jsx(ThemeProviderContext.Provider, { value: value, children: children }));
}
export function useTheme() {
    const context = useContext(ThemeProviderContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}
